import ClickTriggerHandler from './click-trigger';
import InViewTriggerHandler from './in-view-trigger';
import PageLoadTriggerHandler from './page-load-trigger';
import ScrollDepthTriggerHandler from './scroll-depth-trigger';

export default [ClickTriggerHandler, InViewTriggerHandler, PageLoadTriggerHandler, ScrollDepthTriggerHandler];
